import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";
import clsx from "clsx";

import { ButtonToolbar } from "react-bootstrap";

import { isEnabled } from "utils/featureFlags";

import { Button, ButtonGroup, Icon } from "aible";
import { LineInput } from "components/Inputs/LineInput";
import Tooltip from "components/Inputs/Tooltip";

import HexGridContainer from "containers/Next/HexGrid";

import chatIcon from "images/chatbubble.svg";
import KPIDashIcon from "images/chart-line-purple.svg";
import NLQDashIcon from "images/presentation-screen-purple.svg";

import DashboardIcon from "images/HeaderTabs/explore-dashboard.svg";
import ExploreIcon from "images/HeaderTabs/explore.svg";
import AnalyticsIcon from "images/HeaderTabs/analytics.svg";
import OptimizeIcon from "images/HeaderTabs/optimize.svg";
import StructuredDataIcon from "images/HeaderTabs/structured-data.svg";

import * as nextReducer from "containers/Next/NextReducer";
import * as projectReducer from "containers/Project/reducer";
import * as nextTransformReducer from "containers/Next/Transform/TransformReducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as globalReducer from "containers/App/reducer";
import * as viewReducer from "containers/View/reducer";
import * as languageModelArtifactReducer from "containers/LanguageModelArtifact/reducer";

import styles from "./style.module.css";

import OpenShellSandboxSelector from "@/components/Openshell/OpenShellSandboxSelector";

const HeaderTab = (props) => {
  const { title, icon, isActive, onClick, isDisabled, style } = props;
  return (
    <div
      className={clsx(styles.headerTab, isActive && styles.headerTabActive, isDisabled && "hidden")}
      onClick={onClick}
      style={style ? style : {}}
    >
      <div className={styles.headerTabIcon}>{icon}</div>
      <div className={styles.headerTabTitle}>{title}</div>
    </div>
  );
};

const NextHeaderTabs = (props = {}) => {
  const { id, blueprintId, className, onMouseLeave, onMouseOver, previousReportData, ...retProps } = props;

  const dispatch = useDispatch();
  // const history = useHistory();
  const [isHoverGrid, updateIsHoverGrid] = useState(false);

  const activeTab = useSelector((state) => nextReducer.getActiveTab(state, id));
  const updateActiveTab = (activeTab) => dispatch(nextReducer.updateActiveTab(id, activeTab));

  const projectId = useSelector((state) => nextReducer.getProjectId(state, id));
  const isForecastProject = useSelector((state) => projectReducer.getIsForecastProject(state, projectId));

  const chatType = useSelector((state) => chatGPTReducer.getChatType(state));

  const explorationKey = useSelector((state) => nextReducer.getExplorationKey(state, id));
  const savedTransformHexMap = useSelector((state) => nextTransformReducer.getSavedHexMap(state, id));
  const explorations =
    savedTransformHexMap &&
    Object.keys(savedTransformHexMap).filter((hex) => savedTransformHexMap[hex].explorationId !== undefined);
  const hasExploration = explorations && explorations.length > 0;
  const mostRecentExplorationId =
    activeTab !== "EXPLORE" &&
    hasExploration &&
    (explorationKey !== undefined
      ? explorationKey
      : Math.max(...explorations.map((hexKey) => savedTransformHexMap[hexKey].explorationId)));

  const IS_SIMPLE_MODE = true;

  const datasetId = useSelector((state) => nextReducer.getDatasetId(state, id));
  const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
  const hasDataset = dataset !== undefined && datasetId > 0;
  const hasOutcome = hasDataset && dataset?.outcome;

  const hexMap = useSelector((state) => nextReducer.getHexMap(state, id));
  const hasHexes = hexMap && Object.keys(hexMap)?.length > 0;
  const uiState = useSelector((state) => globalReducer.getUiState(state));
  const isShareLink = uiState?.type === "SHARE_LINK";
  const isSmallScreen = useSelector((state) => viewReducer.getIsSmallScreen(state));
  const handleKPIAnalysis = () => dispatch(chatGPTReducer.handleKPIAnalysis());
  const isKPIAnalysis = useSelector((state) => homeReducer.getIsKPIAnalysis(state, datasetId));

  const optimizeSetup = useSelector((state) => chatGPTReducer.getOptimizeSetup(state));

  const [mouseTab, updateMouseTab] = useState(undefined);

  const isWhatsChanged = chatType === "WHATS_CHANGED";
  const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
  const linkedOptimizeReport = chatApp?.wizard?.linkedOptimizeReport;

  return chatType === "OPENSHELL" ? (
    <div className={styles.leftHeader + " " + (className ? className : "")}>
      <OpenShellSandboxSelector />
    </div>
  ) : (
    <div
      className={
        IS_SIMPLE_MODE
          ? styles.leftHeader + " " + (className ? className : "")
          : styles.centerHeader + " " + (className ? className : "")
      }
      onMouseOver={(e) => {
        updateIsHoverGrid(true);
        onMouseOver && onMouseOver(e);
      }}
      onMouseLeave={(e) => {
        updateIsHoverGrid(false);
        onMouseLeave && onMouseLeave(e);
      }}
      {...retProps}
    >
      {IS_SIMPLE_MODE && isEnabled("chat-aible") && (
        <React.Fragment>
          <div className={styles.tHover}>
            <HeaderTab
              title={"Chat"}
              icon={<Icon src={chatIcon} />}
              isActive={activeTab === "CHATGPT"}
              onClick={() => updateActiveTab("CHATGPT")}
              isDisabled={optimizeSetup !== undefined ? false : projectId !== undefined && !hasExploration}
              style={{ padding: "0px 20px" }}
            />
          </div>
        </React.Fragment>
      )}
      <div
        className={styles.tHover}
        onMouseEnter={(e) => updateMouseTab("TRANSFORM")}
        onMouseLeave={(e) => updateMouseTab(undefined)}
      >
        <HeaderTab
          title={"Data"}
          icon={<Icon src={StructuredDataIcon} />}
          isActive={activeTab === "TRANSFORM"}
          onClick={() => updateActiveTab("TRANSFORM")}
          style={{ padding: "0px 20px" }}
          isDisabled={!hasOutcome || chatType === "KPI_ANALYSIS"} //This breaks KPI analysis if you click this then switch to the kpi analysis. No idea why
        />
        {mouseTab === "TRANSFORM" && (
          <div className={styles.tHex}>
            <HexGridContainer id={id} isMini mType={"TRANSFORM"} isHoverHex isHover={isHoverGrid} />
          </div>
        )}
      </div>
      <div
        className={styles.tHover}
        onMouseEnter={(e) => updateMouseTab("EXPLORE")}
        onMouseLeave={(e) => updateMouseTab(undefined)}
      >
        {IS_SIMPLE_MODE ? (
          <HeaderTab
            title={"Explore"}
            icon={<Icon size={22} src={ExploreIcon} />}
            isActive={activeTab === "EXPLORE"}
            onClick={() => updateActiveTab("EXPLORE")}
            style={{ padding: "0px 20px" }}
            isDisabled={!hasOutcome || !hasHexes}
          />
        ) : (
          <HeaderTab
            title={"Explore"}
            icon={<Icon size={22} src={ExploreIcon} />}
            isActive={
              activeTab === "EXPLORE" ||
              activeTab === "CHATGPT" ||
              activeTab === "DASHBOARD" ||
              activeTab === "NLQ Dashboard"
            }
            onClick={() => updateActiveTab("PREVIOUS_VIEW")}
            style={{ padding: "0px 20px" }}
            isDisabled={!hasOutcome || !hasHexes}
          />
        )}
        {hasExploration && mouseTab === "EXPLORE" && (
          <div className={styles.tHex}>
            <HexGridContainer
              id={id}
              nextId={activeTab !== "EXPLORE" ? id : undefined}
              isMini
              mType={"EXPLORE"}
              explorationId={mostRecentExplorationId}
              isHoverHex
              isHover={isHoverGrid}
            />
          </div>
        )}
      </div>
      {IS_SIMPLE_MODE && !isShareLink && isEnabled("aible-dashboard") && !isSmallScreen && (
        <div className={styles.tHover}>
          <HeaderTab
            title={"Dashboard"}
            icon={<Icon src={DashboardIcon} />}
            isActive={activeTab === "DASHBOARD"}
            onClick={() => updateActiveTab("DASHBOARD")}
            isDisabled={!hasOutcome || !hasHexes}
            style={{ padding: "0px 20px" }}
          />
        </div>
      )}
      {IS_SIMPLE_MODE && isEnabled(`document-set-kpi-analysis`) && isKPIAnalysis && !isSmallScreen && (
        <div className={styles.tHover}>
          <HeaderTab
            title={"What's Changed Overview"}
            icon={<Icon src={KPIDashIcon} />}
            isActive={activeTab === "KPI DASHBOARD"}
            onClick={() => {
              updateActiveTab("KPI DASHBOARD");
              handleKPIAnalysis();
            }}
            isDisabled={!isKPIAnalysis}
            style={{ padding: "0px 20px" }}
          />
        </div>
      )}
      {projectId !== undefined && isForecastProject ? (
        <div className={styles.tHover}>
          <HeaderTab
            title={"Forecasting"}
            icon={<Icon src={OptimizeIcon} />}
            isActive={activeTab === "FORECASTING"}
            onClick={() => updateActiveTab("FORECASTING")}
            isDisabled={projectId === undefined || !isForecastProject}
            style={{ padding: "0px 20px" }}
          />
        </div>
      ) : (
        <React.Fragment />
      )}
      {(projectId === undefined || !isForecastProject) && isEnabled("aible-explore") !== true ? (
        <div
          className={styles.tHover}
          onMouseEnter={(e) => updateMouseTab("MODELS")}
          onMouseLeave={(e) => updateMouseTab(undefined)}
        >
          <HeaderTab
            title={"AI Creation"}
            icon={<Icon src={OptimizeIcon} />}
            isActive={activeTab === "MODELS"}
            onClick={() => updateActiveTab("MODELS")}
            isDisabled={projectId === undefined && blueprintId === undefined}
            style={{ padding: "0px 20px" }}
          />
          {mouseTab === "MODELS" && (
            <div className={styles.tHex}>
              <HexGridContainer id={id} isMini mType={"MODELS"} isHoverHex isHover={isHoverGrid} />
            </div>
          )}
        </div>
      ) : (
        <React.Fragment />
      )}
      {isEnabled("aible-explore") !== true && !isForecastProject && (
        <div className={styles.tHover}>
          <HeaderTab
            title={"AI Impact Monitoring"}
            icon={<Icon src={AnalyticsIcon} />}
            isActive={activeTab === "MONITOR"}
            onClick={() => updateActiveTab("MONITOR")}
            isDisabled={projectId === undefined}
            style={{ padding: "0px 20px" }}
          />
        </div>
      )}
      {isEnabled("whats-changed-strategy-project-switching") &&
        isWhatsChanged &&
        linkedOptimizeReport !== undefined && (
          <Button
            onClick={async () => {
              let retReportId = id;
              if (retReportId === "new" || isNaN(Number(retReportId))) {
                retReportId = await dispatch(chatGPTReducer.handleAutoSave());
              }
              const currentReportInfo = {
                reportId: retReportId,
                datasetId: datasetId
              };
              dispatch(
                nextReducer.switchProjectInChat(currentReportInfo, linkedOptimizeReport, uiState, true, "OPTIMIZE")
              );
            }}
          >
            Adjust Strategy
          </Button>
        )}
      {isEnabled("whats-changed-strategy-project-switching") &&
        chatType === "OPTIMIZE" &&
        previousReportData !== undefined && (
          <Button
            onClick={() => {
              const currentReportInfo = {
                reportId: id,
                datasetId: datasetId
              };
              dispatch(nextReducer.switchProjectInChat(currentReportInfo, previousReportData, uiState));
            }}
          >
            Back to What's Changed Project
          </Button>
        )}
    </div>
  );
};

export default NextHeaderTabs;
